<ngx-spinner
	bdColor="rgba(75, 55, 100, 0.5)"
	size="large"
	color="#fff"
	type="line-scale-pulse-out">
	<span class="chevron left"></span>
	<span class="chevron right"></span>
</ngx-spinner>
<div class="m-grid__item m-grid__item--fluid m-wrapper" *ngIf="form">
	<div class="m-content">
			<!-- FORM -->
			<form
			[formGroup]="form"
			*ngIf="form"
			class="m-form m-form--fit m-form--label-align-right">
				<div>
					<!-- EVENT -->
					<div class="m-portlet">
						<div class="m-portlet__head">
							<div class="m-portlet__head-caption">
								<div class="m-portlet__head-title">
									<h3 class="m-portlet__head-text" *ngIf="!ppw">
										PLEDGE PER WIN CAMPAIGN INFORMATION
									</h3>
								</div>
							</div>
						</div>
						<div class="m-portlet__body">
							<div formGroupName="event" class="m-form__section m-form__section--first">
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Campaign Name:
									</label>
                  <span [hidden]="formControls('event').controls.name.value" class="required-asterisk text-danger">*</span>
									<div class="col-lg-3">
										<input
											formControlName="name"
											type="text"
											id="name"
											class="form-control m-input"
											placeholder=""
											/>
										<app-validation-display
                      *ngIf="formControls('event').controls.name?.value.length < 30"
                      [control]="formControls('event').controls.name"
											errorMessage="Campaign name is required"
											></app-validation-display>
                    <app-validation-display
                      *ngIf="formControls('event').controls.name?.value.length > 30"
                      [control]="formControls('event').controls.name"
                      errorMessage="Campaign name length must be less than 30"
                    ></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Campaign Start/End Date:
									</label>
									<div class="col-lg-3">
										<app-service-period
										[minDays]="0"
										[showTooltip]="false"
										formControlName="realEventPeriod"
										></app-service-period>
										<span class="m-form__help">
										Customer facing time period for which this Campaign will remain active</span
											><br />
										<app-validation-display
											[control]="formControls('event').controls.realEventPeriod"
											errorMessage="Please select a valid date range for this Campaign"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Fundraising Goal:
									</label>
                  <span [hidden]="formControls('event').controls.fundraisingGoal.value" class="required-asterisk text-danger">*</span>
									<div class="col-lg-3">
										<label class="input-dollar-sign col-form-label">
										$
										</label>
										<input
											formControlName="fundraisingGoal"
											type="number"
											(blur)="removeLeadingZeros($event, formControls('event').controls.fundraisingGoal)"
											pattern="\d+(\.\d{1,2})?"
											id="fundraisingGoal"
											class="input-dollar-field form-control m-input"
											/>
										<app-validation-display
                      *ngIf="formControls('event').controls.fundraisingGoal.value < 1000000"
                      [control]="formControls('event').controls.fundraisingGoal"
											errorMessage="Please enter in a valid dollar amount"
										></app-validation-display>
                    <app-validation-display
                      *ngIf="formControls('event').controls.fundraisingGoal.value > 1000000"
                      [control]="formControls('event').controls.fundraisingGoal"
                      errorMessage="Maximum goal must be less than $1,000,000"
                    ></app-validation-display>
									</div>
								</div>

								<!--
									<div class="form-group m-form__group row">
										<label class="col-lg-4 col-form-label">
										Terms of Service URL:
										</label>
										<div class="col-lg-3">
											<input
												formControlName="termsOfServiceUrl"
												type="text"
												id="termsOfServiceUrl"
												pattern="^https://[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?"
												class="form-control m-input"
												placeholder="https://"
												/>
											<app-validation-display
												[control]="formControls('event').controls.termsOfServiceUrl"
												errorMessage="Please supply a valid link to your Terms of Service"
												></app-validation-display>
										</div>
									</div>




									<div class="form-group m-form__group row">
										<label class="col-lg-4 col-form-label">
										Primary Color:
										</label>
										<div class="col-lg-3">
											<input formControlName="primaryColor" [cpAlphaChannel]="'disabled'" maxlength="7" class="form-control m-input"
											[value]="formControls('event').controls.primaryColor.value"
											(colorPickerChange)="formControls('event').controls.primaryColor.value = $event; formControls('event').controls.primaryColor.updateValueAndValidity();"
											[colorPicker]="formControls('event').controls.primaryColor.value" [cpDisableInput]="true" [style.background]="formControls('event').controls.primaryColor.value">
											<app-validation-display
											[control]="formControls('event').controls.primaryColor"
											errorMessage="Please choose a valid color"
											></app-validation-display>
										</div>
									</div>

													<div class="form-group m-form__group row">
										<label class="col-lg-4 col-form-label">
										Secondary Color:
										</label>
										<div class="col-lg-3">
											<input [cpAlphaChannel]="'disabled'" maxlength="7" class="form-control m-input"
												[value]="formControls('event').controls.secondaryColor.value"
												(colorPickerChange)="formControls('event').controls.secondaryColor.value = $event; formControls('event').controls.secondaryColor.updateValueAndValidity();"
												[colorPicker]="formControls('event').controls.secondaryColor.value"
												[cpDisableInput]="true"
												formControlName="secondaryColor"
												[style.background]="formControls('event').controls.secondaryColor.value">
											<app-validation-display
												[control]="formControls('event').controls.secondaryColor"
												errorMessage="Please choose a valid color"
												></app-validation-display>
														</div>
									</div>

													<div class="form-group m-form__group row">
										<label class="col-lg-4 col-form-label">
										Logo Image:
										</label>
										<div class="col-lg-3">


										</div>
									</div>

													<div class="form-group m-form__group row">
										<label class="col-lg-4 col-form-label">
										Banner Image:
										</label>
										<div class="col-lg-3">


										</div>
									</div> -->
							</div>
							<div class="m-form__section m-form__section--first">
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Sort Order:
									</label>
                  <span [hidden]="formControls('sortOrder').value" class="required-asterisk text-danger">*</span>
									<div class="col-lg-3">
										<select
											formControlName="sortOrder"
											id="name"
											class="form-control m-input"
										>
											<option value="0">-- Select a Sort Order --</option>
											<option
												*ngFor="let item of counter; let i = index;"
												[value]="i + 1"
												[selected]="this.form.controls.sortOrder === i + 1"
											>
												{{i + 1}}
											</option>
										</select>
										<span class="m-form__help">
											This number will determine in what order this Campaign appears in the portal as well as the order it appears on the customer-facing website.
										</span><br />
										<app-validation-display
											[control]="formControls('sortOrder')"
											errorMessage="Please enter a valid sort order greater than 0."
										></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Team:
									</label>
                  <span [hidden]="formControls('teamId').value" class="required-asterisk text-danger">*</span>
									<div class="col-lg-3">
										<select
											formControlName="teamId"
											class="col-lg-12 col-m-4 form-control m-input"
											id="teamId"
											name="merchantIdSelect"
											>
											<option selected value="0">-- Select a Team --</option>
											<option
											*ngFor="let t of teams"
											[selected]="t.teamId === formControls('teamId').value"
											[value]="t.teamId"
											>
											{{ t.name }}
											</option>
										</select>
										<span class="m-form__help">
										Choose a team from this list that will benefit from this Campaign.
										</span><br />
										<p style="color:red; padding: 0; font-family: 'Open Sans', sans-serif; font-size: 12px; font-weight: 300;"
											*ngIf="cue5050?.status > 1">
											Cannot edit the team of a Campaign once it has occurred
										</p>
										<app-validation-display
											[control]="formControls('teamId')"
											errorMessage="Team is required"
											></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Pledge Per:
									</label>
                  <span [hidden]="formControls('statistic').value" class="required-asterisk text-danger">*</span>
									<div class="col-lg-3">
										<input
											formControlName="statistic"
											type="text"
											id="name"
											class="form-control m-input"
											placeholder="Win"
											/>
										<app-validation-display
											[control]="formControls('statistic')"
											errorMessage="Statistic is required"
										></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Custom New Subscriber Email Message:
									</label>
                  <span [hidden]="formControls('newSubscriberEmailMessage').value" class="required-asterisk text-danger">*</span>
									<div class="col-lg-3">
										<textarea
											formControlName="newSubscriberEmailMessage"
											type="text"
											id="name"
											class="form-control m-input"
											rows="6"
											></textarea>
										<span class="m-form__help">
											Your subscribers will see this message in an email when they first sign up.</span
												><br />
										<app-validation-display
											[control]="formControls('newSubscriberEmailMessage')"
											errorMessage="Please enter a valid custom message."
										></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Custom Game Over Email Message:
									</label>
                  <span [hidden]="formControls('gameOverEmailMessage').value" class="required-asterisk text-danger">*</span>
									<div class="col-lg-3">
										<textarea
											formControlName="gameOverEmailMessage"
											type="text"
											id="name"
											class="form-control m-input"
											rows="6"
											></textarea>
										<app-validation-display
											[control]="formControls('gameOverEmailMessage')"
											errorMessage="Please enter a valid custom message."
										></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Custom Game Over Text Message:
									</label>
                  <span [hidden]="formControls('gameOverTextMessage').value" class="required-asterisk text-danger">*</span>
									<div class="col-lg-3">
										<textarea
											formControlName="gameOverTextMessage"
											type="text"
											id="name"
											class="form-control m-input"
											rows="6"
											></textarea>
									<span class="m-form__help">
										Your subscribers wil see these messages in an email/text after a game. Keep in mind that they aren't necessarily being charged after every game.
										You'll also get the opportunity to provide an additional custom message when you complete the game in the portal where you can include more details about the game like score, your opponent, etc.</span
											><br />
										<app-validation-display
											[control]="formControls('gameOverTextMessage')"
											errorMessage="Please enter a valid custom message."
										></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Custom Subscription Charge Email Message:
									</label>
                  <span [hidden]="formControls('subscriptionChargeEmailMessage').value" class="required-asterisk text-danger">*</span>
									<div class="col-lg-3">
										<textarea
											formControlName="subscriptionChargeEmailMessage"
											type="text"
											id="name"
											class="form-control m-input"
											rows="6"
											></textarea>
										<app-validation-display
											[control]="formControls('subscriptionChargeEmailMessage')"
											errorMessage="Please enter a valid custom message."
										></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Custom Subscription Charge Text Message:
									</label>
                  <span [hidden]="formControls('subscriptionChargeTextMessage').value" class="required-asterisk text-danger">*</span>
									<div class="col-lg-3">
										<textarea
											formControlName="subscriptionChargeTextMessage"
											type="text"
											id="name"
											class="form-control m-input"
											rows="6"
											></textarea>
										<span class="m-form__help">
											Your subscribers wil see these messages after they've been charged.</span
												><br />
										<app-validation-display
											[control]="formControls('subscriptionChargeTextMessage')"
											errorMessage="Please enter a valid custom message."
										></app-validation-display>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Custom Checkout Page Message:
									</label>
                  <span [hidden]="formControls('customCheckoutCopy').value" class="required-asterisk text-danger">*</span>
									<div class="col-lg-3">
										<textarea
											formControlName="customCheckoutCopy"
											type="text"
											id="name"
											class="form-control m-input"
											rows="6"
											></textarea>
										<span class="m-form__help">
											Your subscribers will see this message when they're on the checkout page of the customer-facing website.</span
												><br />
										<app-validation-display
											[control]="formControls('customCheckoutCopy')"
											errorMessage="Please enter a valid custom message."
										></app-validation-display>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- END EVENT -->
				</div>

				<!--LOCATION -->
				<app-location-form
				*ngIf="form"
				formName="CAMPAIGN LOCATION"
				[disableForm]="true"
				[disableSelection]="eventId > 0"
				[parentGroup]="formControls('event')"
				[locationData]="ppw?.event.location">
				</app-location-form>
				<!--END LOCATION -->

				<!-- TICKET TIERS -->
				<div class="m-portlet" style="width: 100%">
					<div class="m-portlet__head">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-title">
								<h3 class="m-portlet__head-text">
									PLEDGE PER WIN TIERS
								</h3>
							</div>
						</div>
					</div>
					<div class="m-portlet__body" style="padding-top: 0;">
						<div class="m-form__section m-form__section--first">
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label"></label>
								<div  class="col-lg-3">
									<span class="m-form__help" style="font-weight: 800;">
									Create the pricing tiers available for purchase. These will appear as a product list on your fundraiser website
									</span><br />
									<span class="m-form__help">
									Ex: $5, $10, $20 Per Win.
									</span>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-4 col-form-label">
								Pledge Tiers:
								</label>
								<div class="col-lg-4">
									<div
										formArrayName="pledgePerWinPricingTiers"
										*ngFor="let t of formControls('pledgePerWinPricingTiers').controls; let i = index"
										>
										<div *ngIf="t" [formGroupName]="i" style="display: flex; justify-content: start;" [ngStyle]="{'padding-top': i !== 0 ? '15px' : '0'}">
										<div style="display: flex; width: 100px;">
											<label style="font-size: 1.2rem; margin-top: 7px; margin-right: 3px;">$</label>
											<input
											formControlName="price"
											style="width: 90px;"
											(blur)="removeLeadingZeros($event, t.controls.price)"
											pattern="(^[1-9]+(\d+)?(\.\d\d)?)|(^0\.\d[1-9])|(^0\.[1-9]\d)$"
											id="tierPrice"
											type="text"
											[ignoreWhiteSpace]
											class="form-control m-input"
											placeholder="Price"
											/>
										</div>
										<a *ngIf="i !== 0 && (!eventId || (ppw?.event.status === 2 && !t.controls.pledgePerWinPricingTierId?.value) || (ppw?.event.status === 1))"
											(click)="deletePricingTier(i)"
											href="#"
											class="m-menu__link"
											style="text-decoration: none; margin-top: 5px; position: relative; left: 8px;">
										<i class="m-menu__link-icon flaticon-cancel"></i>
										</a>
										<div *ngIf="i === 0" style="width: 4%;"> </div>
									</div>
									<app-validation-display
										[control]="t.controls.price"
										errorMessage="Please enter in a valid price greater than zero"
										></app-validation-display>
								</div>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label class="col-lg-4 col-form-label"></label>
							<div class="col-lg-3">
								<a (click)="newPricingTier()" style="text-decoration: none;" href="#">+ New Tier</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- END TICKET TIERS -->

		</form>
		<!-- END FORM -->

		<div class="form-group m-form__group row">
			<div class="col-lg-12">
				<button *ngIf="!viewing || cloning" [debounceClick]  [disabled]="loading" type="submit" (click)="save()" class="btn btn-primary">
				{{ eventId ? "Update" : "Create" }}
				</button>
				<button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
				{{ viewing && !cloning ? 'Go Back' : 'Cancel'}}
				</button>
				<div *ngIf="hasValidationErrors">
					<span style="color:red">Please complete the required fields</span>
				</div>
			</div>
		</div>

	</div>
</div>
